import React from "react";
import { Button, Container, Typography } from "@material-ui/core";

import Header from "../../components/Header/Header";
import Footer from "../../components/Footer/Footer";

interface AboutProps {
  cartCount?: number;
  onCartClick?: () => void;
}

const About: React.FC<AboutProps> = ({
  cartCount = 0,
  onCartClick = () => {},
}) => {
  return (
    <div className="about-page">

      {/* Header */}
      <Header
        cartCount={cartCount}
        onCartClick={onCartClick}
      />

      {/* =========================================
          ABOUT OUR ONLINE
      ========================================= */}
      <section className="about-online-section">
        <Container maxWidth="lg">
          <div className="about-online-wrapper">

            {/* LEFT IMAGES */}
            <div className="about-images">

              <div className="about-image-main">
                <img
                  src="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1000&q=90"
                  alt="Fresh organic vegetables"
                />
              </div>

              <div className="about-green-block" />

              <div className="about-image-secondary">
                <img
                  src="https://images.unsplash.com/photo-1604187351574-c75ca79f5807?auto=format&fit=crop&w=900&q=90"
                  alt="Organic shopping"
                />
              </div>

            </div>

            {/* RIGHT CONTENT */}
            <div className="about-online-content">

              <Typography className="about-eyebrow">
                Our Story
              </Typography>

              <Typography className="about-main-title">
                About Our Online
              </Typography>

              <Typography className="about-description">
                Pellentesque habitant morbi tristique senectus et
                netus et malesuada fames ac turpis egestas.
                Vestibulum tortor quam, feugiat vitae, ultricies eget,
                tempor sit amet, ante. Donec eu libero sit amet quam
                egestas semper. Aenean ultricies mi vitae est.
              </Typography>

              <div className="about-features">

                <div className="about-feature">
                  <Typography className="about-feature-title">
                    Trusted By Thousands
                  </Typography>

                  <Typography className="about-feature-text">
                    Pellentesque habitant morbi tristique
                  </Typography>
                </div>

                <div className="about-feature">
                  <Typography className="about-feature-title">
                    Best Services
                  </Typography>

                  <Typography className="about-feature-text">
                    Pellentesque habitant morbi tristique
                  </Typography>
                </div>

              </div>

              <Button className="about-read-button">
                READ MORE
              </Button>

            </div>

          </div>
        </Container>
      </section>

      {/* =========================================
          WHO WE ARE
      ========================================= */}
      <section className="who-we-are-section">
        <Container maxWidth="lg">

          <div className="who-we-are-heading">

            <Typography className="who-eyebrow">
              We Act Precisely
            </Typography>

            <Typography className="who-title">
              Who We Are
            </Typography>

            <Typography className="who-description">
              Pellentesque habitant morbi tristique senectus et netus
              et malesuada fames ac turpis egestas. Vestibulum tortor
              quam, feugiat vitae, ultricies eget, tempor sit amet,
              ante. Donec eu libero sit amet quam egestas semper.
              Aenean ultricies mi vitae est.
            </Typography>

          </div>

          <div className="who-images">

            <div className="who-image">
              <img
                src="https://images.unsplash.com/photo-1542838132-92c53300491e?auto=format&fit=crop&w=1200&q=90"
                alt="Organic vegetables"
              />
            </div>

            <div className="who-image">
              <img
                src="https://images.unsplash.com/photo-1501004318641-b39e6451bec6?auto=format&fit=crop&w=1200&q=90"
                alt="Fresh organic produce"
              />
            </div>

          </div>

        </Container>
      </section>

      <Footer />

    </div>
  );
};

export default About;